class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    //included this line to handle when the user pres'ENTER'
    facetForm.addEventListener("submit", (event) => {
      event.preventDefault();
      this.onSubmitHandler(event);
    });

    //use this event to activate the search when the user clicks on the mobile brand input 
    facetForm.addEventListener("click", (event) => {
      event.preventDefault();
      console.log('click event: ', event.target);
      if(event.target.classList.contains("brandlist-mobile")){
        this.onSubmitHandler(event);
      }
      const { target } = event;
        if(target.tagName === "A"){
          const href = target.getAttribute("href");
          window.location = href;
        }
      
    })


    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    const endlessCollection = new Ajaxinate({
      container: "#product-grid",
      pagination: ".infinite_next",
    });
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {    
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";
      
      //HANDLE BRAND FILTER

      //in order for the brands filter to work, we need to watch out for 3 possible events
      //input - fired when the user select an option from the datalist
      //insertText - fired when the user types something in the input
      //submit - fired when the user press enter and submit the form.

      //to ensure the event is actually coming from the input field, we need to check if the target that trigged the event is the brandListInput
      //or if the current active element is the brandListInput.
      //we need to check for both, because the 'input' and the 'inserText' events will be trigged by the brandListInput, 
      //however the 'submit' event is triggered by the actual form that wrapps the brandListInput. If that's the case, we need to check if the brandListInput is currently active.
      if (event.target.classList.contains("brandListInput") || document.activeElement.classList.contains("brandListInput") ) {
        if(!isMobile){
          let value = document.querySelector(".brandListInput").value.length > 0 ? document.querySelector(".brandListInput").value : document.activeElement.value
          if(!value.length > 0 && !event.target?.value?.length > 0 && !document.activeElement?.value?.length > 0){
            //clear out brand filter
            var currentUrl = location.pathname + location.search
            const url = currentUrl.replace(/\/brand-.*\?/, "?");
            return location = url;
          }
          const datalist = document.querySelector("#brandDataList");
          //check selected from datalist
          const selected = Array.from(datalist.options).find(
            (option) => option.value.toLowerCase() === value.toLowerCase()
          );
          //to avoid changing the location url when the user types (insertText event) a matching brand,
          //we return null if the event is 'insertText'
          if (!selected || event.inputType === 'insertText') {
            return;
          }
          const url = selected.dataset.value;
          return location = url;
        }else{
          //WHEN ON MOBILE, SHOW LIST OF POSSIBLE OPTIONS 
          //*** IMPORTANT - DATALIST ELEMENT SHOULD STILL BE ON THE PAGE SO WE CAN GET DATA FROM IT
          //** WE NEED TO HIDE IT
          const value = document.querySelector(".brandlist-mobile").value;
          let datalist = document.querySelector("#brandDataList");
          //HIDE DATALIST - ensure datalist won't be shown
          datalist.style.display = "none"
          
          const search = Array.from(datalist.options).filter(
            (option) => option.value.toLowerCase().search(value.toLowerCase()) >= 0
          ).map(option => option.value);
          
          const parent = document.querySelector(".brandlist-mobile").parentElement.parentElement.parentElement;
          let output = parent.querySelector("#brandList-mobile-results")
          if(!output){
             output = document.createElement("UL");
             output.setAttribute("id", "brandList-mobile-results");
             output.style.maxHeight = "350px"
             output.style.overflowY = "scroll"
             output.style.backgroundColor = "#F1F1F1"
             output.style.paddingBlock = "10px"
             output.style.listStyle = 'none';
             parent.append(output)
          }

          output.innerHTML = ""
          search.forEach(brand => {
            let listItem = document.createElement("LI");
            listItem.innerHTML = brand
            listItem.onclick = (el) => {
              document.querySelector(".brandlist-mobile").value = brand
              output.innerHTML = ""
              output.append(listItem)
            }
            output.append(listItem)
          })
          
        }
      }

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

//UPDATE BRAND SEARCH INPUT

//get the current url and find the corresponding option
const currenUrl = window.location.pathname + window.location.search;
const datalist = document.querySelector("#brandDataList");
const selected = Array.from(datalist.options).find(
  (option) => option.dataset.value === currenUrl
);
if (selected) {
  const input = document.querySelector(".brandListInput");
  const mobinput = document.querySelector(".brandlist-mobile");
  input.value = selected.value;
  mobinput.value = selected.value;
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

document.getElementById("apply-filters").addEventListener(
  "click",
  function (event) {
    event.preventDefault();
    let mobileFilters = "";

    if (document.getElementById("storelist-mobile").value != "") {
      mobileFilters += "+" + document.getElementById("storelist-mobile").value;
    }
    if (document.getElementById("sizelist-mobile").value != "") {
      mobileFilters += "+" + document.getElementById("sizelist-mobile").value;
    }
    if (document.getElementById("colorlist-mobile").value != "") {
      mobileFilters += "+" + document.getElementById("colorlist-mobile").value;
    }
    if (document.querySelector(".brandlist-mobile").value != "") {
     const value = document.querySelector(".brandlist-mobile").value;
     const datalist = document.querySelector("#brandDataList");
      //check selected from datalist
      const selected = Array.from(datalist.options).find(
        (option) => option.value.toLowerCase() === value.toLowerCase()
      );
      if(selected){
        const brand = /(brand-.*)\?/.exec(selected.dataset.value)[1];
        mobileFilters += "+" + brand;
      }
      else{
        alert("Invalid Brand")
      }
    }
    mobileFilters = mobileFilters.substring(1);
    document.getElementById("mobileFilter").value +=
      mobileFilters +
      "?sort_by=" +
      document.getElementById("SortBy-mobile").value;
    
    window.location.href = document.getElementById("mobileFilter").value;
  },
  false
);
document.getElementById("reset-filters").addEventListener(
  "click",
  function (event) {
    event.preventDefault();
    document.getElementById("storelist-mobile").value = "";
    document.getElementById("stylelist-mobile").value = "";
    document.getElementById("colorlist-mobile").value = "";
    document.getElementById("brandlist-mobile").value = "";
    window.location.href = document.getElementById("mobileFilter").value;
  },
  false
);
